/**
 *
 * Qlist
 *
 */

import { mapGetters } from 'vuex';

import Paginate from 'vuejs-paginate';

import { PageNoMixin } from '@/scripts/QA/QuestionList/mixins/PageNoMixin';

export default {
  name: 'QaQuestionList',

  mixins: [PageNoMixin],

  components: {
    Paginate,
  },

  computed: {
    ...mapGetters('QA/QuestionList', {
      mg_itemsCount: 'itemsCount',
      mg_pageCount: 'pageCount',
      mg_questionList: 'questionList',
    }),

    c_isMyQaPage() {
      return (
        'myquestion' === this.$route.query.qType ||
        'myanswer' === this.$route.query.qType ||
        'myfollows' === this.$route.query.qType
      );
    },

    c_isShowPaginate() {
      return this.mg_pageCount > 0;
    },
  },

  methods: {
    handlePageChange(pageNo) {
      this.$emit('page-change', pageNo);
    },
  },
};
